import { Footer } from "../components/footer";
import { Header } from "../components/header";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useEffect, useState } from "react";
import { trackPageView } from "../utils/segment";
import { createClient } from "contentful";
import Loading from "../components/loading";

export function OurWines() {
  const [loading, setLoading] = useState(true);
  const [wineCollections, setWineCollections] = useState([]);

  useEffect(() => {
    // window.scrollTo({ top: 0 });
    trackPageView("Product List Viewed");
    handleFetchWines();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!wineCollections.length) return;
    const [, collectionTag] = window.location.href.split("#");
    const linkElement = document.getElementById(`${collectionTag}`);
    if (linkElement) {
      linkElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [wineCollections.length]);

  const client = createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_API_KEY,
  });

  const handleFetchWines = async () => {
    setLoading(true);
    try {
      const { items } = await client.getEntries({
        "sys.contentType.sys.id": "wineCollection",
        order: "sys.createdAt",
      });
      setWineCollections(items);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide, totalItems, slidesToShow },
    } = rest;
    return (
      <div className="slider-buttons carousel-button-group">
        <button
          className={
            currentSlide === 0
              ? "disable"
              : "" +
                "react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
          }
          onClick={() => previous()}
        />
        <button
          className={
            currentSlide === totalItems - slidesToShow ||
            totalItems <= slidesToShow
              ? "disable"
              : "" +
                "react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
          }
          onClick={() => next()}
        />
      </div>
    );
  };

  return (
    <>
      <Header />
      <div className="container-fluid our-wines-container">
        {loading ? (
          <div className="page-loader">
            <Loading />
          </div>
        ) : (
          <div className="wine-collection">
            {wineCollections.map((wineCollection, key) => (
              <div
                className="item"
                key={wineCollection.sys.id}
                id={wineCollection.fields.tag.split("#")[1]}
              >
                <h4 className="item-title">
                  {wineCollection.fields.collectionName} Collection
                </h4>
                <div className="wine-item-flex">
                  <Carousel
                    responsive={responsive}
                    renderButtonGroupOutside={true}
                    arrows={false}
                    customButtonGroup={<ButtonGroup />}
                  >
                    {wineCollection.fields.wines.map((wine, wineKey) => (
                      <div className="wine-item" key={wineKey}>
                        <div className="wine-item-image">
                          <img
                            src={wine.fields.image.fields.file.url}
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                        <p className="name">{wine.fields.name}</p>
                        <div className="info">
                          <span>750ml</span>
                          <i className="bi bi-dot"></i>
                          <span>9% ABV</span>
                        </div>
                      </div>
                    ))}
                  </Carousel>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer collectionFooter={true} />
    </>
  );
}
